module.exports = __webpack_public_path__ + "img/e8ea0e9.jpg";